import React from 'react'
import { faBullhorn } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { useAppNavigate } from '../../../context/AppContext'
import PandaModal from '../../../components/panda-modal/PandaModal'
import { getGeneralInfo } from '../../../utils/generalInfo'

type Props = {
  isOpen: boolean
  setIsOpen?: (isOpen: boolean) => void
}

const AnnouncementModal = (props: Props) => {
  const { t } = useTranslation()
  const navigate = useAppNavigate()
  const generalInfo = getGeneralInfo()

  const close = () => {
    props.setIsOpen?.(false)
    navigate('/')
  }

  return (
    <PandaModal
      isOpen={props.isOpen}
      onClose={close}
      actionLabel={t('CLOSE')}
      badge={faBullhorn}
    >
      <p>{generalInfo?.announcement}</p>
    </PandaModal>
  )
}

export default AnnouncementModal
